// extracted by mini-css-extract-plugin
module.exports = {"table":"CompanyGeneralSettingsSkeleton_table__3YJ3I","tableRow":"CompanyGeneralSettingsSkeleton_tableRow__SNq6Q"};